import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const MissionCode11ResonanceSocietyPage = () => {
  const handleDownloadPDF = () => {
    // Direct download link from Google Drive - same file as on landing page
    const link = document.createElement('a');
    link.href = 'https://drive.google.com/uc?export=download&id=1Hzj3gbaEMMTFzgREs5eCbRe-iQixlulX';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link?.click();
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-foreground text-background py-4 sticky top-0 z-50 shadow-md">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <Icon name="ArrowLeft" size={24} />
            <span className="text-sm font-medium">Назад на главную</span>
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Heart" size={20} color="white" />
            </div>
            <span className="font-bold">AI Dating</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Код 11: Резонансное общество
          </h1>
          <p className="text-xl text-foreground/70">
            Дом Объективной Морали
          </p>
        </div>

        {/* Content Sections */}
        <article className="prose prose-lg max-w-none">
          {/* Intro Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">Простыми словами: что это такое и зачем</h2>
            <p className="text-foreground/80 mb-4">
              Представьте, что общество — это огромный город, где люди постоянно "сталкиваются": в семье, на работе, в очередях, в интернете.
            </p>
            <p className="text-foreground/80 mb-4">
              И большая часть конфликтов происходит не потому что люди "плохие", а потому что они живут в режиме:
            </p>
            <div className="bg-background-light p-6 rounded-lg mb-6">
              <p className="text-foreground font-semibold text-xl mb-4 text-center">
                "Я не хочу, но вынужден."
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>не хочу работать, но надо платить ипотеку</li>
                <li>не хочу быть в отношениях, но одному страшно и дорого</li>
                <li>не хочу терпеть начальника, но иначе нечем кормить детей</li>
                <li>не хочу жить в этом городе, но некуда ехать</li>
              </ul>
            </div>
            <p className="text-foreground/80 mb-4">
              СОЛ-общество — это попытка сделать так, чтобы вынужденных связей стало меньше, а добровольных и честных — больше.
            </p>
            <p className="text-foreground/80 mb-4">
              Это общество, где норма — когда человек:
            </p>
            <ol className="list-decimal pl-6 text-foreground/80 space-y-2 mb-6">
              <li>хочет,</li>
              <li>согласен,</li>
              <li>и ему реально можно (есть условия и безопасность).</li>
            </ol>
            <div className="bg-primary/10 border-l-4 border-primary p-6 rounded-r-lg mb-6">
              <p className="text-foreground/80 mb-2">
                В RaaP модели это называется "Код:11111":
              </p>
              <p className="text-foreground font-semibold">
                все стороны хотят, согласны, и среда не мешает.
              </p>
            </div>
          </section>

          {/* How it Works Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">Как это работает на практике (без магии)</h2>
            
            {/* UBI */}
            <div className="mb-10">
              <h3 className="text-2xl font-semibold text-foreground mb-4">1) UBI — базовый доход для всех</h3>
              <p className="text-foreground/80 mb-4">
                Это не "зарплата за воздух" и не "коммунизм".
              </p>
              <p className="text-foreground/80 mb-4">
                Это страховка, что человек не станет рабом обстоятельств.
              </p>
              <p className="text-foreground/80 mb-4">UBI закрывает минимальный уровень:</p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-4">
                <li>еда</li>
                <li>жильё (простое)</li>
                <li>медицина базовая</li>
                <li>связь / транспорт минимум</li>
              </ul>
              <p className="text-foreground font-semibold text-lg mb-2">Зачем это нужно?</p>
              <p className="text-foreground/80 mb-4">
                Чтобы люди не попадали в отношения и работу из отчаяния.
              </p>
              <p className="text-foreground/80 mb-4">
                UBI — это выключатель режима "выживание".
              </p>
              <p className="text-foreground/80">
                А без этого выключателя никакой "любви", "свободы" и "этики" не получится — будет вечная драка за ресурсы.
              </p>
              
              {/* International UBI Resources */}
              <div className="mt-8 bg-background-light border-l-4 border-primary p-6 rounded-r-lg">
                <h4 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Icon name="Globe" size={24} />
                  Основные международные ресурсы
                </h4>
                <div className="space-y-4">
                  <div>
                    <p className="text-foreground/80 mb-2">
                      <strong>Basic Income Earth Network (BIEN)</strong> — международная сеть, посвящённая образованию и исследованиям по базовому доходу.
                    </p>
                    <a 
                      href="https://basicincome.org" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
                    >
                      <Icon name="ExternalLink" size={16} />
                      Basic Income Earth Network - https://basicincome.org
                    </a>
                  </div>
                  
                  <div>
                    <p className="text-foreground/80 mb-2">
                      <strong>USBIG – U.S. Basic Income Guarantee Network / Resources</strong> — большая подборка ресурсов об UBI, ссылок на организации, исследования и статьи.
                    </p>
                    <a 
                      href="https://usbig.net" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
                    >
                      <Icon name="ExternalLink" size={16} />
                      USBIG Resources - https://usbig.net
                    </a>
                  </div>
                  
                  <div>
                    <p className="text-foreground/80 mb-2">
                      <strong>Stanford Basic Income Lab – What is UBI?</strong> — объяснение концепции, исторический контекст и исследования.
                    </p>
                    <a 
                      href="https://basicincome.stanford.edu" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
                    >
                      <Icon name="ExternalLink" size={16} />
                      Stanford Basic Income Lab - https://basicincome.stanford.edu
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* RaaP Protocol */}
            <div className="mb-10">
              <h3 className="text-2xl font-semibold text-foreground mb-4">2) RaaP — протокол отношений и взаимодействий</h3>
              <p className="text-foreground/80 mb-4">Это простая идея:</p>
              <p className="text-foreground/80 mb-4">
                как у интернета есть правила передачи данных (протоколы),
              </p>
              <p className="text-foreground/80 mb-4">
                так и у отношений должны быть понятные правила, чтобы люди не мучили друг друга.
              </p>
              <p className="text-foreground/80 mb-4">
                Например, в обществе Код 11 считается нормой:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-4">
                <li>не давить</li>
                <li>не удерживать</li>
                <li>не манипулировать страхом</li>
                <li>не делать человека зависимым</li>
                <li>всегда оставлять право выйти</li>
              </ul>
              <p className="text-foreground/80 mb-6">
                То есть: если кто-то рядом с вами живёт, работает или "любит" только потому что ему некуда идти — это уже не любовь и не партнёрство. Это зависимость.
              </p>
              
              {/* PDF Download Button */}
              <div className="bg-accent/30 border border-accent/50 rounded-lg p-6">
                <p className="text-secondary mb-4">
                  Подробнее о RaaP протоколе можно узнать в методическом пособии:
                </p>
                <button
                  onClick={handleDownloadPDF}
                  className="inline-flex items-center gap-3 px-6 py-3 bg-primary text-primary-foreground rounded-lg font-semibold hover:bg-primary/90 transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  <Icon name="Download" size={20} />
                  <span>Скачать методичку (PDF)</span>
                </button>
              </div>
            </div>

            {/* AI Tools */}
            <div className="mb-10">
              <h3 className="text-2xl font-semibold text-foreground mb-4">3) ИИ и цифровые инструменты — чтобы не выбирать "вслепую"</h3>
              <p className="text-foreground/80 mb-4">Самая большая боль современного мира — ошибки выбора:</p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-4">
                <li>не тот партнёр → развод, депрессия, дети в конфликте</li>
                <li>не та работа → выгорание, ненависть к жизни</li>
                <li>не тот город → одиночество и стресс</li>
              </ul>
              <p className="text-foreground/80 mb-4">
                Раньше люди выбирали "по ощущениям", "как повезёт", "как родители сказали".
              </p>
              <p className="text-foreground/80 mb-4">Теперь можно использовать ИИ, чтобы:</p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-4">
                <li>понять себя</li>
                <li>понять другого</li>
                <li>заранее увидеть несовместимость</li>
                <li>не тратить годы на мучения</li>
              </ul>
              <div className="bg-background-light p-6 rounded-lg">
                <p className="text-foreground/80 mb-2">
                  Это не "машина решит за вас".
                </p>
                <p className="text-foreground/80">
                  Это как навигатор: ехать всё равно вам, но он показывает пробки и тупики.
                </p>
              </div>
            </div>
          </section>

          {/* Main Fear Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">Главный страх людей: "Если всем дать деньги — кто будет работать?"</h2>
            <p className="text-foreground/80 mb-4">Отличный вопрос. И он правильный.</p>
            <p className="text-foreground font-semibold text-lg mb-4">Ответ:</p>
            <p className="text-foreground/80 mb-6">
              будут работать те, кому это выгодно, интересно, престижно или важно.
            </p>
            <p className="text-foreground/80 mb-4">
              А работы, которые никто не любит, будут решаться 4 способами.
            </p>

            {/* 4 Ways */}
            <div className="space-y-6 mb-6">
              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">Способ 1. Повышение оплаты за неприятную работу</h4>
                <p className="text-foreground/80 mb-2">
                  Если работа тяжёлая/грязная/скучная — она должна оплачиваться выше.
                </p>
                <p className="text-foreground/80 mb-2">
                  Это честно: "если обществу это нужно — оно платит".
                </p>
                <p className="text-foreground/70 text-sm">Пример: уборка улиц, сортировка мусора, ночные смены.</p>
              </div>

              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">Способ 2. Автоматизация</h4>
                <p className="text-foreground/80 mb-2">
                  Если работу никто не хочет — значит, это лучший кандидат на роботов и автоматизацию.
                </p>
                <p className="text-foreground/80 mb-2">Так уже произошло с:</p>
                <ul className="list-disc pl-6 text-foreground/70 text-sm space-y-1">
                  <li>частью заводов</li>
                  <li>кассирами (самообслуживание)</li>
                  <li>доставкой (частично)</li>
                  <li>бухгалтерией (частично)</li>
                </ul>
              </div>

              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">Способ 3. Ротация</h4>
                <p className="text-foreground/80 mb-2">
                  Некоторые вещи можно делать по очереди и не превращать их в пожизненную каторгу.
                </p>
                <p className="text-foreground/70 text-sm">Например, общественные проекты: локальные комьюнити-задачи.</p>
              </div>

              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">Способ 4. Социальный статус и "геймификация"</h4>
                <p className="text-foreground/80 mb-2">
                  Есть работы, которые неприятные, но важные.
                </p>
                <p className="text-foreground/80 mb-2">
                  Если общество умеет давать уважение и статус за пользу — люди идут туда.
                </p>
                <p className="text-foreground/70 text-sm">Пример: медики, пожарные, инженеры инфраструктуры</p>
              </div>
            </div>

            <div className="bg-primary/10 border-l-4 border-primary p-6 rounded-r-lg">
              <p className="text-foreground font-semibold text-lg">
                Итого: в СОЛ-обществе работа не исчезает. Исчезает рабство.
              </p>
            </div>
          </section>

          {/* Second Fear Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">Второй страх: "Все станут наркоманами и бездельниками"</h2>
            <p className="text-foreground/80 mb-4">
              Часть людей действительно "ляжет на диван".
            </p>
            <p className="text-foreground/80 mb-4">
              Но важно понимать: это происходит и сейчас — просто в другом виде.
            </p>
            <p className="text-foreground/80 mb-4">Сегодня миллионы людей:</p>
            <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-6">
              <li>сидят в депрессии</li>
              <li>работают "на автомате"</li>
              <li>употребляют алкоголь/таблетки</li>
              <li>живут в постоянной тревоге</li>
            </ul>
            <p className="text-foreground/80 mb-6">
              Разница в том, что сейчас это часто выглядит "прилично", потому что человек ходит на работу.
            </p>

            <h3 className="text-2xl font-semibold text-foreground mb-4">Что будет при UBI?</h3>
            <p className="text-foreground/80 mb-4">Будет 3 категории реакций:</p>

            <div className="space-y-6 mb-6">
              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">1. Восстановление</h4>
                <p className="text-foreground/80 mb-2">
                  Люди впервые выдохнут. Поспят. Приведут здоровье в порядок.
                </p>
                <p className="text-foreground/80">
                  И через несколько месяцев вернутся к деятельности, потому что человеку скучно без смысла.
                </p>
              </div>

              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">2. Переобучение</h4>
                <p className="text-foreground/80 mb-2">
                  Люди начнут менять профессии, учиться, пробовать.
                </p>
                <p className="text-foreground/80">
                  Это не деградация — это нормальная адаптация.
                </p>
              </div>

              <div className="bg-background-light p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-foreground mb-3">3. Зависание</h4>
                <p className="text-foreground/80 mb-2">
                  Да, небольшой процент "залипнет" в развлечениях.
                </p>
                <p className="text-foreground/80 mb-2">Но это не катастрофа, потому что они:</p>
                <ul className="list-disc pl-6 text-foreground/70 text-sm space-y-1">
                  <li>не опасны</li>
                  <li>не отбирают ресурсы у других через насилие</li>
                  <li>не вынуждены ломать жизнь другим ради выживания</li>
                </ul>
              </div>
            </div>

            <div className="bg-primary/10 border-l-4 border-primary p-6 rounded-r-lg mb-6">
              <p className="text-foreground/80 mb-2">
                А главное: в СОЛ-обществе есть ключевой принцип:
              </p>
              <p className="text-foreground font-semibold">
                "Тёмные импульсы — в безопасную виртуальность, а не в реальность."
              </p>
            </div>
            <p className="text-foreground/80">
              То есть человек может играть в жёсткие игры, смотреть кино, выпускать агрессию в симуляции — но не переносить это на людей.
            </p>
          </section>

          {/* Degeneration Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">"Не выродится ли человечество?"</h2>
            <p className="text-foreground/80 mb-4">
              Наоборот. Есть сильный аргумент, почему оно может стать лучше.
            </p>
            <p className="text-foreground/80 mb-4">Сейчас человечество деградирует скрыто:</p>
            <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-6">
              <li>дети растут в стрессовых семьях</li>
              <li>люди вступают в отношения из нужды</li>
              <li>рожают "чтобы удержать"</li>
              <li>работают на износ</li>
              <li>психика ломается</li>
            </ul>
            <p className="text-foreground/80 mb-4">СОЛ-общество делает другое:</p>
            <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-6">
              <li>меньше семей "по необходимости"</li>
              <li>больше семей "по желанию"</li>
              <li>меньше насилия в быту</li>
              <li>больше психически устойчивых людей</li>
              <li>меньше травм у детей</li>
            </ul>
            <div className="bg-background-light p-6 rounded-lg">
              <p className="text-foreground/80 mb-2">
                Это не "утопия".
              </p>
              <p className="text-foreground font-semibold">
                Это просто снижение брака в производстве человека.
              </p>
            </div>
          </section>

          {/* What's the Catch Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">Тогда в чём подвох? Почему это вообще спорно?</h2>
            <p className="text-foreground/80 mb-4">
              Потому что такая система рушит старую модель контроля.
            </p>
            <p className="text-foreground/80 mb-4">Сейчас очень многое держится на страхе:</p>
            <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-6">
              <li>потерять работу</li>
              <li>остаться без денег</li>
              <li>остаться одному</li>
              <li>быть осуждённым</li>
            </ul>
            <p className="text-foreground/80 mb-4">
              UBI + протокол согласия = человек становится свободнее.
            </p>
            <p className="text-foreground/80 mb-4">А свободный человек:</p>
            <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-6">
              <li>не терпит токсичное</li>
              <li>не продаёт себя за копейки</li>
              <li>не соглашается на унижение</li>
            </ul>
            <p className="text-foreground/80">
              И для многих старых структур это страшно.
            </p>
          </section>

          {/* Children Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">"А если люди не будут рожать детей?"</h2>
            <p className="text-foreground/80 mb-4">
              В мире, где дети появляются в бедности и страхе, рождаемость падает сама.
            </p>
            <p className="text-foreground/80 mb-4">
              Люди не хотят рожать "в стресс".
            </p>
            <p className="text-foreground/80 mb-4">
              В СОЛ-обществе дети чаще будут появляться, когда:
            </p>
            <ul className="list-disc pl-6 text-foreground/80 space-y-2 mb-6">
              <li>есть ресурс</li>
              <li>есть желание</li>
              <li>есть стабильность</li>
              <li>есть партнёрство, а не выживание</li>
            </ul>
            <div className="bg-primary/10 border-l-4 border-primary p-6 rounded-r-lg">
              <p className="text-foreground font-semibold">
                То есть детей станет меньше случайных, но больше желанных.
              </p>
              <p className="text-foreground/80 mt-2">
                Это качественный рост, а не "массовка".
              </p>
            </div>
          </section>

          {/* Summary Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-foreground mb-6">Короткое резюме</h2>
            <p className="text-foreground/80 mb-4">
              Код 11 / СОЛ-общество — это мир, где:
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name="Check" size={20} className="text-primary" />
                </div>
                <p className="text-foreground/80">
                  никто не обязан жить с нелюбимым человеком ради выживания
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name="Check" size={20} className="text-primary" />
                </div>
                <p className="text-foreground/80">
                  никто не обязан терпеть унижение ради денег
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name="Check" size={20} className="text-primary" />
                </div>
                <p className="text-foreground/80">
                  тяжёлую работу делают либо за хорошие деньги, либо роботы
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name="Check" size={20} className="text-primary" />
                </div>
                <p className="text-foreground/80">
                  агрессию выпускают безопасно (игры/спорт/VR), а не дома
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name="Check" size={20} className="text-primary" />
                </div>
                <p className="text-foreground/80">
                  отношения строятся на честном "хочу и согласен", а не на "некуда идти"
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1">
                  <Icon name="Check" size={20} className="text-primary" />
                </div>
                <p className="text-foreground/80">
                  ИИ помогает выбирать людей и проекты без многолетних ошибок
                </p>
              </div>
            </div>
            <div className="bg-foreground text-background p-8 rounded-lg text-center">
              <p className="text-xl font-bold mb-2">И главный тезис:</p>
              <p className="text-2xl font-bold mb-4">Это не общество без труда.</p>
              <p className="text-2xl font-bold">Это общество без принуждения.</p>
            </div>
          </section>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-foreground text-background py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-background/70 hover:text-background transition-colors">
            <Icon name="ArrowLeft" size={20} />
            <span>Вернуться на главную</span>
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default MissionCode11ResonanceSocietyPage;